<div class="tire-add-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-user font-20 font-gray-45 header-icon"></i>
        <div class="pl-1 tire-description width-100p p-relative" *ngIf="!isSubletSupplierType">
          <p class="m-0 font-secondary-700 font-14 font-bold" *ngIf="!supplierId">Create new supplier</p>
          <p class="m-0 font-secondary-700 font-14 font-bold capitalize" *ngIf="supplierId">{{supplier?.supplierName}}
          </p>
        </div>

        <!-- Sublet supplier type -->
        <div class="pl-1 tire-description width-100p p-relative" *ngIf="isSubletSupplierType">
          <p class="m-0 font-secondary-700 font-14 font-bold" *ngIf="!supplierId">Create new sublet supplier</p>
          <p class="m-0 font-secondary-700 font-14 font-bold capitalize" *ngIf="supplierId">{{supplier?.supplierName}}
          </p>
        </div>

        <app-switch-pill position="start" [fontSize]="12" [isActive]="supplier.isActive"
          [label]="supplier.isActive ? 'Active' : 'Inactive'" (appChange)="handleChange('isActive', $event)">
        </app-switch-pill>
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>


  <!-- Start Add Tire Body -->
  <div class="ui-g tire-body pt-0 pb-0 border-bottom-light">
    <div class="ui-g-12 inputs-column-spacing tire-inner-body">
      <div class="ui-g-12 p-zero pl-0 customer-type-switch switchButtonDot" *ngIf="!isSubletSupplierType">
        <div class="font-gray-35 font-11 mb-1">Type</div>
        <app-switch-button id="customer-type-switch" valueField="value" paddingClass="p-1" [disabled]="supplierTypes[1]"
          [fontSize]="14" [showselectedCircle]="true" [value]="supplier?.type" [showIcons]="true"
          [options]="supplierTypes" (appChange)="handleChange('type', $event)">
        </app-switch-button>
      </div>

      <!-- Supplier name & Display name -->
      <div class="ui-g-12 p-zero pl-0" [ngClass]="{'mt-3': !isSubletSupplierType}">
        <div class="pr-15" [ngClass]="[isAccountPayablePayment ? 'ui-g-4' : 'ui-g-6' ]">
          <app-input id="fleet-name" validationId="error-fleet-name" placeholder="Supplier name*"
            [disabled]="supplier?.type?.value === 'online'" [errorMessage]="validate.supplierName"
            [isInvalid]="validate.supplierName" [value]="supplier.supplierName" [floatingLabel]="true" [maxLength]="75"
            (appChange)="handleChange('supplierName', $event)" (appFocus)="handleFocus('supplierName')">
          </app-input>
        </div>

        <div [ngClass]="[isAccountPayablePayment ? 'ui-g-4' : 'ui-g-6' ]">
          <app-input id="display-name" validationId="error-display-name" placeholder="Display name*"
            [disabled]="supplier?.type?.value === 'online'" [errorMessage]="validate.name" [isInvalid]="validate.name"
            [value]="supplier.name" [floatingLabel]="true" [maxLength]="75" (appChange)="handleChange('name', $event)"
            (appFocus)="handleFocus('name')"></app-input>
        </div>

        <div class="ui-g-4 pl-15" *ngIf="isAccountPayablePayment">
          <app-dropdown id="term-type" listId="term-type" placeholder="Payment Term" theme="primary" field="label"
            [value]="{ label: supplier?.accPayableTerm?.name }" [fontSize]="14" [listItemFontSize]="13"
            [floatingLabel]="true" [options]="paymentTerms" [isDropdownIconVisible]="true"
            (appSelect)="handleChange('accPayableTerm', $event)">
          </app-dropdown>

          <!-- <app-dropdown
                  placeholder="Select"
                  position="top"
                  field="name"
                  scrollHeight="200px"
                  [id]="'payment-selection-' + supplier.accPayableTerm"
                  [listId]="'payment-selection-' + supplier?.accPayableTerm + '-list'"
                  [fontSize]="12"
                  [setPositionDynamically]="false"
                  [options]="paymentTerms"
                  [isDropdownIconVisible]="true"
                  [value]="selectedPaymentMethod"
                  (appSelect)="onCardTypeSelect($event)"
                >
                </app-dropdown> -->
        </div>
      </div>

      <!-- Account number & URL -->
      <div class="ui-g-12 p-zero pl-0 mt-3">
        <!-- internal supplier reference -->
        <div class="ui-g-4 pr-15 flex-row" *ngIf="isSubletSupplierType && isAccountPayablePayment">
          <app-auto-complete
            class="w-100"
            id="qbo-type"
            textAreaId="qbo-type"
            listId="qbo-type"
            placeholder="Internal supplier reference"
            label="Internal supplier reference"
            theme="inline"
            scrollHeight="160px"
            field="qbo-type"
            [suggestions]="getSupplierNames()"
            [floatingLabel]="true"
            [fontSize]="14"
            [closeOnSelection]="true"
            [value]="selectedSupplierName"
            (appSelect)="selectSupplierRef($event)"
            (appCompletedMethod)="onInternalSupplierSearch($event)"
            (appClear)="onInternalSupplierClear()"
            (appFocus)="showSuggestions('qboResponse')">
            <ng-template let-item appTemplate="editable">
              <div id="est-add-customer" class="p-1" (click)="createNewSupplier()">
                <span class="font-12">+ Create new supplier in QBO</span>
              </div>
            </ng-template>
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">{{ item.name }}</div>
              </div>
            </ng-template>
          </app-auto-complete>
          <span class="flex-start-center pointer">
            <i class="far fa-info-circle font-gray-35" [pTooltip]="'Use this to map this sublet supplier to an existing QBO supplier by selecting the corresponding internal supplier in AL'" tooltipPosition="top" tooltipStyleClass="labor-rate-tooltip"></i>
          </span>
        </div>

          <div class="pr-15 ui-g-4" *ngIf="!isSubletSupplierType">
            <app-input id="supplierId" validationId="error-supplierId" placeholder="Supplier ID"
            [errorMessage]="validate.supplierId" [isInvalid]="validate.supplierId"
            [value]="supplier.supplierId" [floatingLabel]="true" [maxLength]="75"
            (appChange)="handleChange('supplierId', $event)" (appFocus)="handleFocus('supplierId')">
          </app-input>
        </div>
        
        <div class="ui-g-4" >
          <app-input id="fleet-name" validationId="error-fleet-name" placeholder="Account number"
          [errorMessage]="validate.accountNumber" [isInvalid]="validate.accountNumber"
          [value]="supplier.accountNumber" [floatingLabel]="true" [maxLength]="75"
          (appChange)="handleChange('accountNumber', $event)" (appFocus)="handleFocus('accountNumber')">
        </app-input>
      </div>
      
        <div class="pl-15 ui-g-4">
        <app-input id="display-name" validationId="error-display-name" placeholder="URL" [errorMessage]="validate.url"
        [isInvalid]="validate.url" [value]="supplier.url" [floatingLabel]="true" [maxLength]="75"
        (appChange)="handleChange('url', $event)" (appFocus)="handleFocus('URL')"
        (appBlur)="handleBlur('url')"></app-input>
    </div>
      </div>

      <div class="ui-g-12 p-zero pl-0  font-14 font-gray-45  ml-2 mt-2 font-bold">Point(s) of contact</div>

      <!-- Phone -->
      <div class="ui-g-12 p-zero pl-1 mt-30" *ngFor="let phone of supplier?.phones; let phoneIndex = index">
        <div class="ui-g-2 p-0 height-34">
          <app-dropdown id="phone-type-{{phoneIndex}}" listId="phone-list-type-{{phoneIndex}}" placeholder="Type"
            theme="primary" field="label" [hasError]="errors.phones[phoneIndex]?.contactType"
            [value]="phone.contactType" [errorMessage]="errors.phones[phoneIndex]?.contactType" [fontSize]="14"
            [listItemFontSize]="13" [floatingLabel]="true" [options]="phoneTypes" [isDropdownIconVisible]="true"
            (appSelect)="handleMultiChange('phones', 'contactType', phoneIndex, $event)">
          </app-dropdown>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="phone-{{phoneIndex}}" validationId="error-phone-{{phoneIndex}}" placeholder="Phone"
            mask="(000) 000-0000" [value]="phone.value" [isInvalid]="errors.phones[phoneIndex]?.value"
            [errorMessage]="errors.phones[phoneIndex]?.value" [floatingLabel]="true"
            (appChange)="handleMultiChange('phones', 'value', phoneIndex, $event)"
            (appFocus)="handleMultiFocus('phones', 'value', phoneIndex, true)"
            (appBlur)="handleMultiFocus('phones', 'value', phoneIndex, false)"></app-input>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="phone-label-{{phoneIndex}}" validationId="error-phone-label-{{phoneIndex}}" placeholder="Label"
            [value]="phone.label" [floatingLabel]="true" [isInvalid]="errors.phones[phoneIndex]?.label"
            [errorMessage]="errors.phones[phoneIndex]?.label"
            (appChange)="handleMultiChange('phones', 'label', phoneIndex, $event)"
            (appFocus)="handleMultiFocus('phones', 'label', phoneIndex, true)"
            (appBlur)="handleMultiFocus('phones', 'label', phoneIndex, false)">
          </app-input>
        </div>

        <div class="ui-g-4 p-0 pl-4 height-34">
          <div class="ui-g-12 p-0 pt-2">
            <div class="ui-g-6 p-0 flex-column height-34 position-relative flex-end-start pb-2">
              <p class="m-0 floating-label font-seconday">
                Primary

                <i class="contact-status-tooltip fal fa-info-circle text-dark font-45"
                  pTooltip="Choose mobile no. as primary contact as all SMS will be sent to this number"
                  tooltipPosition="top"></i>
              </p>

              <app-radio-button id="phone-primary-{{phoneIndex}}" name="phone-primary" label="Primary"
                styleClassLabel="font-seconday" [selectedValue]="phone?.isPrimary"
                [ngClass]="{'not-allowed': !phone?.isActive || phone?.contactType?.value === 'landline' || !phone?.value}"
                [disabled]="!phone?.isActive || phone?.contactType?.value === 'landline' || !phone?.value"
                [value]="true" (appChange)="handleMultiChange('phones', 'isPrimary', phoneIndex, $event)">
              </app-radio-button>
            </div>

            <div class="ui-g-4 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <p class="m-0 floating-label font-seconday">Active</p>

              <app-switch-pill id="phone-active-{{phoneIndex}}" position="end" [fontSize]="14"
                [isActive]="phone.isActive" [disabled]="phone?.isPrimary" [label]="phone.isActive ? 'Yes' : 'No'"
                (appChange)="handleMultiChange('phones', 'isActive', phoneIndex, $event)">
              </app-switch-pill>


            </div>
            <div class="ui-g-2 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!phone?.isPrimary && phoneIndex"
                style="right:0px" pTooltip="Delete" tooltipPosition="top"
                (click)="handleDeleteContact('phones', phoneIndex)"></i>
            </div>
          </div>
        </div>

      </div>
      <!-- Add new phone -->
      <div class="ui-g-12 p-zero pl-2 mt-2" *ngIf="supplier?.phones.length < 5">
        <span class="m-0 flex-start-center font-primary pointer" id="add-another-phone"
          (click)="handleAddAnother('phone')">
          <i class="fas fa-plus-circle pr-1"></i>
          <span class="font-12">Add another phone</span>
        </span>
      </div>

      <!-- Emails -->
      <div class="ui-g-12 p-zero pl-1 mt-30" *ngFor="let email of supplier?.emails; let emailIndex = index">
        <div class="ui-g-2 p-0 height-34">
          <app-dropdown id="email-type-{{emailIndex}}" listId="email-list-type-{{emailIndex}}" placeholder="Type"
            theme="primary" field="label" [hasError]="errors.emails[emailIndex]?.contactType"
            [value]="email.contactType" [errorMessage]="errors.emails[emailIndex]?.contactType" [fontSize]="14"
            [listItemFontSize]="13" [floatingLabel]="true" [options]="[]" [disabled]="true"
            [isDropdownIconVisible]="true" (appSelect)="handleMultiChange('emails', 'contactType', emailIndex, $event)">
          </app-dropdown>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="email-{{emailIndex}}" validationId="error-email-{{emailIndex}}" placeholder="Email"
            [errorMessage]="errors.emails[emailIndex]?.value" [isInvalid]="errors.emails[emailIndex]?.value"
            [value]="email.value" [floatingLabel]="true" [maxLength]="253"
            (appChange)="handleMultiChange('emails', 'value', emailIndex, $event)"
            (appFocus)="handleMultiFocus('emails', 'value', emailIndex, true)"
            (appBlur)="handleMultiFocus('emails', 'value', emailIndex, false)">
          </app-input>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="email-label-{{emailIndex}}" validationId="error-email-label-{{emailIndex}}" placeholder="Label"
            [value]="email.label" [floatingLabel]="true" [errorMessage]="errors.emails[emailIndex]?.label"
            [isInvalid]="errors.emails[emailIndex]?.label"
            (appChange)="handleMultiChange('emails', 'label', emailIndex, $event)"
            (appFocus)="handleMultiFocus('emails', 'label', emailIndex, true)"
            (appBlur)="handleMultiFocus('emails', 'label', emailIndex, false)"></app-input>
        </div>

        <div class="ui-g-4 p-0 pl-4 height-34">
          <div class="ui-g-12 p-0 pt-2">
            <div class="ui-g-6 p-0 flex-column height-34 position-relative flex-end-start pb-2">
              <p class="m-0 floating-label">
                Primary
                <i class="contact-status-tooltip fal fa-info-circle text-dark font-45"
                  pTooltip="Choose primary email address. All communication by default will be sent to primary email address"
                  tooltipPosition="top"></i>
              </p>

              <app-radio-button id="email-primary-{{emailIndex}}" name="email-primary" label="Primary"
                styleClassLabel="font-seconday" [selectedValue]="email?.isPrimary"
                [ngClass]="{'not-allowed': !email?.isActive|| !email?.value}"
                [disabled]="!email?.isActive|| !email?.value" [value]="true"
                (appChange)="handleMultiChange('emails', 'isPrimary', emailIndex, $event)">
              </app-radio-button>
            </div>

            <div class="ui-g-4 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <p class="m-0 floating-label">Active</p>

              <app-switch-pill id="email-active-{{emailIndex}}" position="end" [fontSize]="14"
                [isActive]="email.isActive" [disabled]="email?.isPrimary" [label]="email.isActive ? 'Yes' : 'No'"
                (appChange)="handleMultiChange('emails', 'isActive', emailIndex, $event)">
              </app-switch-pill>


            </div>
            <div class="ui-g-2 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!email?.isPrimary && emailIndex"
                style="right:0px" pTooltip="Delete" tooltipPosition="top"
                (click)="handleDeleteContact('emails', emailIndex)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Add new email -->
      <div class="ui-g-12 p-zero pl-2 mt-2" *ngIf="supplier?.emails.length < 5">
        <span class="m-0 flex-start-center font-primary pointer" id="add-another-email"
          (click)="handleAddAnother('email')">
          <i class="fas fa-plus-circle pr-1"></i>
          <span class="font-12">Add another email</span>
        </span>
      </div>

      <!-- Warehouse Address -->
      <div class="ui-g-12 p-zero mt-28">
        <div class="ui-g-6 p-point25rem">
          <app-input id="address-1" [placeholder]="isSubletSupplierType ? 'Shop address' : 'Warehouse address'" [value]="supplier?.wareHouseAddress?.addLine1"
            [floatingLabel]="true" [maxLength]="160" (appChange)="handleChange('wareHouseAddress-addLine1', $event)"
            (appFocus)="handleFocus('addLine1')"></app-input>
        </div>
        <!-- Zip code -->
        <div class="ui-g-3 pr-15 p-point25rem">
          <app-input id="zip-1" validationId="error-zip-1" placeholder="Zip" [errorMessage]="validate.zip"
            [isInvalid]="validate.zip" [value]="supplier?.wareHouseAddress?.zip" [floatingLabel]="true" [maxLength]="7"
            (appChange)="handleChange('wareHouseAddress-zip', $event)" (appFocus)="handleFocus('zip')"
            (appBlur)="zipChange($event, 'wareHouseAddress')"></app-input>
        </div>

        <!-- City -->
        <div class="ui-g-3 p-zero">
          <div class="city-auto-complete-align">
            <app-auto-complete id="city-1" textAreaId="city-1" listId="list-city-1" placeholder="Search city"
              label="City" field="city" theme="inline" scrollHeight="160px" [floatingLabel]="true" [fontSize]="14"
              [closeOnSelection]="true"
              [value]="renderCityName(supplier?.wareHouseAddress?.city, supplier?.wareHouseAddress?.stateCode)"
              [suggestions]="addressCityResults" (appSelect)="onAddressCitySelect($event)"
              (appCompletedMethod)="addressCitySearch($event)" (appClear)="onAddressCityClear()">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.city}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
      </div>
      <div class="ui-g-12 p-zero mt-28 mb-2">
        <div class="ui-g-6 p-point25rem">
          <app-input id="address-2" placeholder="Billing address" [value]="supplier?.billingAddress?.addLine1"
            [floatingLabel]="true" [maxLength]="160" (appChange)="handleChange('billingAddress-addLine1', $event)"
            (appFocus)="handleFocus('billingAddress')"></app-input>
        </div>
        <div class="ui-g-3 pr-15 p-point25rem">
          <app-input id="zip-2" validationId="error-zip-2" placeholder="Zip" [errorMessage]="validate.zip2"
            [isInvalid]="validate.zip2" [value]="supplier?.billingAddress?.zip" [floatingLabel]="true" [maxLength]="7"
            (appChange)="handleChange('billingAddress-zip', $event)" (appFocus)="handleFocus('zip2')"
            (appBlur)="zipChange($event, 'billingAddress')"></app-input>
        </div>
        <div class="ui-g-3 p-zero">
          <div class="city-auto-complete-align">
            <app-auto-complete id="city-2" textAreaId="city-2" listId="list-city-2" placeholder="Search city"
              label="City" theme="inline" scrollHeight="160px" field="city" [suggestions]="bAddressCityResults"
              [floatingLabel]="true" [fontSize]="14" [closeOnSelection]="true"
              [value]="renderCityName(supplier?.billingAddress?.city, supplier?.billingAddress?.stateCode)"
              (appSelect)="onBaddressCitySelect($event)" (appCompletedMethod)="bAddressCitySearch($event)"
              (appClear)="onBaddressCityClear()">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.city}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
      </div>
      <!-- <div class="ui-g-12 mt-20 p-zero mb-3 tag-list-alignment">
        <app-tags-list buttonId="customer-add-tags" addTagTitle="Add tags" [tags]="supplierTags"
          [type]="tagTypeSupplier" [selectedTags]="supplier?.tags" [fontSize]="11" [hasCreateOption]="true"
          [isDeleteable]="true" (appSelect)="onTagSelect($event)" (appDelete)="onTagDelete($event)"
          (appCreateTag)="onTagCreate($event)" (appShowSuggestion)="onTagFocus()">
        </app-tags-list>
      </div> -->
      <div class="ui-g-12 p-zero mt-28 mb-2">
        <div class="ui-g-6">
          <app-textarea textAreaId="customer-update-notes" name="notes" placeholder="Pinned notes" theme="primary"
            [maxLength]="2000" [floatingLabel]="true"
            [value]="supplier.notes" [rows]="3" [autoGrow]="true" [maxAutoGrowHeight]="64" type="text"
            [autoFocus]="false" (appChange)="handleChange('notes', $event)">
          </app-textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
    <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
      <div></div>
      <div>
        <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
        <button class="btn btn-primary btn-submit" [disabled]="isProcessing" (click)="handleSubmit()">
          <span [ngClass]="{'pr-2': isProcessing}">Save</span>
          <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
</div>